import { Pipe, PipeTransform } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';
import { capitalize } from '@utils/string-utils';

@Pipe({
  name: 'shippingTextPattern',
  standalone: false,
})
export class ShippingTextPattern implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
  transform(text: string, variables: { name: string; value: string }[], additionalText?: string): any {
    if (!text) {
      return '';
    }
    const text1 = text;
    const res = variables.reduce((acc: string, variable) => {
      const re = new RegExp(variable.name, 'g');
      return acc.replace(re, acc.startsWith(variable.name) ? capitalize(variable.value) : variable.value);
    }, text1);
    const result = this.sanitized.bypassSecurityTrustHtml(res + (additionalText || ''));
    return result;
  }
}

@Pipe({ name: 'disableSaveButton', standalone: false })
export class DisableSaveButtonPipe implements PipeTransform {
  transform(
    form: UntypedFormGroup,
    pluginType: ShopPlugin.ProductPagePromise.PluginType,
    config: ShopPlugin.ProService.Config | ShopPlugin.ProductPagePromise.Config,
  ) {
    const firstUse = !!(pluginType === ShopPlugin.ProductPagePromise.PluginType.DEFAULT
      ? !config?.fastestShipping && !config?.cheapestShipping
      : !(<ShopPlugin.ProService.Config>config)?.inventoryConfig);

    return !((firstUse || form.dirty) && form.valid);
  }
}
